/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-44033017.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _path18, _path19, _path20, _path21, _path22, _circle2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _circle3, _circle4, _circle5, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _circle6, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _circle7, _path179, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _circle49, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _circle50, _path213, _path214, _path215, _path216, _path217, _circle51, _path218, _circle52, _path219, _circle53, _path220, _path221, _circle54, _path222, _path223, _circle55, _path224, _circle56, _path225, _path226, _path227;

var _excluded = ["children", "size"],
    _excluded2 = ["children", "size"],
    _excluded3 = ["children", "size"],
    _excluded4 = ["children", "size"],
    _excluded5 = ["children", "size"],
    _excluded6 = ["children", "size"],
    _excluded7 = ["children", "size"],
    _excluded8 = ["children", "size"],
    _excluded9 = ["children", "size"],
    _excluded10 = ["children", "size"],
    _excluded11 = ["children", "size"],
    _excluded12 = ["children", "size"],
    _excluded13 = ["children", "size"],
    _excluded14 = ["children", "size"],
    _excluded15 = ["children", "size"],
    _excluded16 = ["children", "size"],
    _excluded17 = ["children", "size"],
    _excluded18 = ["children", "size"],
    _excluded19 = ["children", "size"],
    _excluded20 = ["children", "size"],
    _excluded21 = ["children", "size"],
    _excluded22 = ["children", "size"],
    _excluded23 = ["children", "size"],
    _excluded24 = ["children", "size"],
    _excluded25 = ["children", "size"],
    _excluded26 = ["children", "size"],
    _excluded27 = ["children", "size"],
    _excluded28 = ["children", "size"],
    _excluded29 = ["children", "size"],
    _excluded30 = ["children", "size"],
    _excluded31 = ["children", "size"],
    _excluded32 = ["children", "size"],
    _excluded33 = ["children", "size"],
    _excluded34 = ["children", "size"],
    _excluded35 = ["children", "size"],
    _excluded36 = ["children", "size"],
    _excluded37 = ["children", "size"],
    _excluded38 = ["children", "size"],
    _excluded39 = ["children", "size"],
    _excluded40 = ["children", "size"],
    _excluded41 = ["children", "size"],
    _excluded42 = ["children", "size"],
    _excluded43 = ["children", "size"],
    _excluded44 = ["children", "size"],
    _excluded45 = ["children", "size"],
    _excluded46 = ["children", "size"],
    _excluded47 = ["children", "size"],
    _excluded48 = ["children", "size"],
    _excluded49 = ["children", "size"],
    _excluded50 = ["children", "size"],
    _excluded51 = ["children", "size"],
    _excluded52 = ["children", "size"],
    _excluded53 = ["children", "size"],
    _excluded54 = ["children", "size"],
    _excluded55 = ["children", "size"],
    _excluded56 = ["children", "size"],
    _excluded57 = ["children", "size"],
    _excluded58 = ["children", "size"],
    _excluded59 = ["children", "size"],
    _excluded60 = ["children", "size"],
    _excluded61 = ["children", "size"],
    _excluded62 = ["children", "size"],
    _excluded63 = ["children", "size"],
    _excluded64 = ["children", "size"],
    _excluded65 = ["children", "size"],
    _excluded66 = ["children", "size"],
    _excluded67 = ["children", "size"],
    _excluded68 = ["children", "size"],
    _excluded69 = ["children", "size"],
    _excluded70 = ["children", "size"],
    _excluded71 = ["children", "size"],
    _excluded72 = ["children", "size"],
    _excluded73 = ["children", "size"],
    _excluded74 = ["children", "size"],
    _excluded75 = ["children", "size"],
    _excluded76 = ["children", "size"],
    _excluded77 = ["children", "size"],
    _excluded78 = ["children", "size"],
    _excluded79 = ["children", "size"],
    _excluded80 = ["children", "size"],
    _excluded81 = ["children", "size"],
    _excluded82 = ["children", "size"],
    _excluded83 = ["children", "size"],
    _excluded84 = ["children", "size"],
    _excluded85 = ["children", "size"],
    _excluded86 = ["children", "size"],
    _excluded87 = ["children", "size"],
    _excluded88 = ["children", "size"],
    _excluded89 = ["children", "size"],
    _excluded90 = ["children", "size"],
    _excluded91 = ["children", "size"],
    _excluded92 = ["children", "size"],
    _excluded93 = ["children", "size"],
    _excluded94 = ["children", "size"],
    _excluded95 = ["children", "size"],
    _excluded96 = ["children", "size"],
    _excluded97 = ["children", "size"],
    _excluded98 = ["children", "size"],
    _excluded99 = ["children", "size"],
    _excluded100 = ["children", "size"],
    _excluded101 = ["children", "size"],
    _excluded102 = ["children", "size"],
    _excluded103 = ["children", "size"],
    _excluded104 = ["children", "size"],
    _excluded105 = ["children", "size"],
    _excluded106 = ["children", "size"],
    _excluded107 = ["children", "size"],
    _excluded108 = ["children", "size"],
    _excluded109 = ["children", "size"],
    _excluded110 = ["children", "size"],
    _excluded111 = ["children", "size"],
    _excluded112 = ["children", "size"],
    _excluded113 = ["children", "size"],
    _excluded114 = ["children", "size"],
    _excluded115 = ["children", "size"],
    _excluded116 = ["children", "size"],
    _excluded117 = ["children", "size"],
    _excluded118 = ["children", "size"],
    _excluded119 = ["children", "size"],
    _excluded120 = ["children", "size"],
    _excluded121 = ["children", "size"],
    _excluded122 = ["children", "size"],
    _excluded123 = ["children", "size"],
    _excluded124 = ["children", "size"],
    _excluded125 = ["children", "size"];
var WatsonHealth3DCursor = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCursor(_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCursor.propTypes = iconPropTypes;
}
var WatsonHealth3DCursorAlt = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCursorAlt(_ref2, ref) {
  var children = _ref2.children,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 16 : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCursorAlt.propTypes = iconPropTypes;
}
var WatsonHealth3DCurveAutoColon = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCurveAutoColon(_ref3, ref) {
  var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 16 : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCurveAutoColon.propTypes = iconPropTypes;
}
var WatsonHealth3DCurveAutoVessels = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCurveAutoVessels(_ref4, ref) {
  var children = _ref4.children,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 16 : _ref4$size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCurveAutoVessels.propTypes = iconPropTypes;
}
var WatsonHealth3DCurveManual = /*#__PURE__*/React.forwardRef(function WatsonHealth3DCurveManual(_ref5, ref) {
  var children = _ref5.children,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 16 : _ref5$size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DCurveManual.propTypes = iconPropTypes;
}
var WatsonHealth3DICa = /*#__PURE__*/React.forwardRef(function WatsonHealth3DICa(_ref6, ref) {
  var children = _ref6.children,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 16 : _ref6$size,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DICa.propTypes = iconPropTypes;
}
var WatsonHealth3DMprToggle = /*#__PURE__*/React.forwardRef(function WatsonHealth3DMprToggle(_ref7, ref) {
  var children = _ref7.children,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 16 : _ref7$size,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DMprToggle.propTypes = iconPropTypes;
}
var WatsonHealth3DPrintMesh = /*#__PURE__*/React.forwardRef(function WatsonHealth3DPrintMesh(_ref8, ref) {
  var children = _ref8.children,
      _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 16 : _ref8$size,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DPrintMesh.propTypes = iconPropTypes;
}
var WatsonHealth3DSoftware = /*#__PURE__*/React.forwardRef(function WatsonHealth3DSoftware(_ref9, ref) {
  var children = _ref9.children,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 16 : _ref9$size,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3DSoftware.propTypes = iconPropTypes;
}
var WatsonHealth3rdPartyConnected = /*#__PURE__*/React.forwardRef(function WatsonHealth3rdPartyConnected(_ref10, ref) {
  var children = _ref10.children,
      _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 16 : _ref10$size,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealth3rdPartyConnected.propTypes = iconPropTypes;
}

var _4K = /*#__PURE__*/React.forwardRef(function _4K(_ref11, ref) {
  var children = _ref11.children,
      _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? 16 : _ref11$size,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  _4K.propTypes = iconPropTypes;
}

var _4KFilled = /*#__PURE__*/React.forwardRef(function _4KFilled(_ref12, ref) {
  var children = _ref12.children,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 16 : _ref12$size,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  _4KFilled.propTypes = iconPropTypes;
}
var Accessibility = /*#__PURE__*/React.forwardRef(function Accessibility(_ref13, ref) {
  var children = _ref13.children,
      _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 16 : _ref13$size,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Accessibility.propTypes = iconPropTypes;
}
var AccessibilityAlt = /*#__PURE__*/React.forwardRef(function AccessibilityAlt(_ref14, ref) {
  var children = _ref14.children,
      _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 16 : _ref14$size,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccessibilityAlt.propTypes = iconPropTypes;
}
var AccessibilityColor = /*#__PURE__*/React.forwardRef(function AccessibilityColor(_ref15, ref) {
  var children = _ref15.children,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? 16 : _ref15$size,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccessibilityColor.propTypes = iconPropTypes;
}
var AccessibilityColorFilled = /*#__PURE__*/React.forwardRef(function AccessibilityColorFilled(_ref16, ref) {
  var children = _ref16.children,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 16 : _ref16$size,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccessibilityColorFilled.propTypes = iconPropTypes;
}
var Account = /*#__PURE__*/React.forwardRef(function Account(_ref17, ref) {
  var children = _ref17.children,
      _ref17$size = _ref17.size,
      size = _ref17$size === void 0 ? 16 : _ref17$size,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8,14H19v2H8Zm0,5H21v2H8Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Account.propTypes = iconPropTypes;
}
var AccumulationIce = /*#__PURE__*/React.forwardRef(function AccumulationIce(_ref18, ref) {
  var children = _ref18.children,
      _ref18$size = _ref18.size,
      size = _ref18$size === void 0 ? 16 : _ref18$size,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccumulationIce.propTypes = iconPropTypes;
}
var AccumulationPrecipitation = /*#__PURE__*/React.forwardRef(function AccumulationPrecipitation(_ref19, ref) {
  var children = _ref19.children,
      _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? 16 : _ref19$size,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccumulationPrecipitation.propTypes = iconPropTypes;
}
var AccumulationRain = /*#__PURE__*/React.forwardRef(function AccumulationRain(_ref20, ref) {
  var children = _ref20.children,
      _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 16 : _ref20$size,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccumulationRain.propTypes = iconPropTypes;
}
var AccumulationSnow = /*#__PURE__*/React.forwardRef(function AccumulationSnow(_ref21, ref) {
  var children = _ref21.children,
      _ref21$size = _ref21.size,
      size = _ref21$size === void 0 ? 16 : _ref21$size,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AccumulationSnow.propTypes = iconPropTypes;
}
var Activity = /*#__PURE__*/React.forwardRef(function Activity(_ref22, ref) {
  var children = _ref22.children,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? 16 : _ref22$size,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Activity.propTypes = iconPropTypes;
}
var Add = /*#__PURE__*/React.forwardRef(function Add(_ref23, ref) {
  var children = _ref23.children,
      _ref23$size = _ref23.size,
      size = _ref23$size === void 0 ? 16 : _ref23$size,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Add.propTypes = iconPropTypes;
}
var AddAlt = /*#__PURE__*/React.forwardRef(function AddAlt(_ref24, ref) {
  var children = _ref24.children,
      _ref24$size = _ref24.size,
      size = _ref24$size === void 0 ? 16 : _ref24$size,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AddAlt.propTypes = iconPropTypes;
}
var AddFilled = /*#__PURE__*/React.forwardRef(function AddFilled(_ref25, ref) {
  var children = _ref25.children,
      _ref25$size = _ref25.size,
      size = _ref25$size === void 0 ? 16 : _ref25$size,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AddFilled.propTypes = iconPropTypes;
}
var AddComment = /*#__PURE__*/React.forwardRef(function AddComment(_ref26, ref) {
  var children = _ref26.children,
      _ref26$size = _ref26.size,
      size = _ref26$size === void 0 ? 16 : _ref26$size,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AddComment.propTypes = iconPropTypes;
}
var AgricultureAnalytics = /*#__PURE__*/React.forwardRef(function AgricultureAnalytics(_ref27, ref) {
  var children = _ref27.children,
      _ref27$size = _ref27.size,
      size = _ref27$size === void 0 ? 16 : _ref27$size,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AgricultureAnalytics.propTypes = iconPropTypes;
}
var WatsonHealthAiResults = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResults(_ref28, ref) {
  var children = _ref28.children,
      _ref28$size = _ref28.size,
      size = _ref28$size === void 0 ? 16 : _ref28$size,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResults.propTypes = iconPropTypes;
}
var WatsonHealthAiResultsHigh = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsHigh(_ref29, ref) {
  var children = _ref29.children,
      _ref29$size = _ref29.size,
      size = _ref29$size === void 0 ? 16 : _ref29$size,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsHigh.propTypes = iconPropTypes;
}
var WatsonHealthAiResultsLow = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsLow(_ref30, ref) {
  var children = _ref30.children,
      _ref30$size = _ref30.size,
      size = _ref30$size === void 0 ? 16 : _ref30$size,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsLow.propTypes = iconPropTypes;
}
var WatsonHealthAiResultsMedium = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsMedium(_ref31, ref) {
  var children = _ref31.children,
      _ref31$size = _ref31.size,
      size = _ref31$size === void 0 ? 16 : _ref31$size,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsMedium.propTypes = iconPropTypes;
}
var WatsonHealthAiResultsUrgent = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsUrgent(_ref32, ref) {
  var children = _ref32.children,
      _ref32$size = _ref32.size,
      size = _ref32$size === void 0 ? 16 : _ref32$size,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsUrgent.propTypes = iconPropTypes;
}
var WatsonHealthAiResultsVeryHigh = /*#__PURE__*/React.forwardRef(function WatsonHealthAiResultsVeryHigh(_ref33, ref) {
  var children = _ref33.children,
      _ref33$size = _ref33.size,
      size = _ref33$size === void 0 ? 16 : _ref33$size,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiResultsVeryHigh.propTypes = iconPropTypes;
}
var WatsonHealthAiStatus = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatus(_ref34, ref) {
  var children = _ref34.children,
      _ref34$size = _ref34.size,
      size = _ref34$size === void 0 ? 16 : _ref34$size,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatus.propTypes = iconPropTypes;
}
var WatsonHealthAiStatusComplete = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusComplete(_ref35, ref) {
  var children = _ref35.children,
      _ref35$size = _ref35.size,
      size = _ref35$size === void 0 ? 16 : _ref35$size,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusComplete.propTypes = iconPropTypes;
}
var WatsonHealthAiStatusFailed = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusFailed(_ref36, ref) {
  var children = _ref36.children,
      _ref36$size = _ref36.size,
      size = _ref36$size === void 0 ? 16 : _ref36$size,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusFailed.propTypes = iconPropTypes;
}
var WatsonHealthAiStatusInProgress = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusInProgress(_ref37, ref) {
  var children = _ref37.children,
      _ref37$size = _ref37.size,
      size = _ref37$size === void 0 ? 16 : _ref37$size,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "7.5",
    r: "1.5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.5",
    cy: "7.5",
    r: "1.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.5",
    cy: "7.5",
    r: "1.5"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusInProgress.propTypes = iconPropTypes;
}
var WatsonHealthAiStatusQueued = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusQueued(_ref38, ref) {
  var children = _ref38.children,
      _ref38$size = _ref38.size,
      size = _ref38$size === void 0 ? 16 : _ref38$size,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusQueued.propTypes = iconPropTypes;
}
var WatsonHealthAiStatusRejected = /*#__PURE__*/React.forwardRef(function WatsonHealthAiStatusRejected(_ref39, ref) {
  var children = _ref39.children,
      _ref39$size = _ref39.size,
      size = _ref39$size === void 0 ? 16 : _ref39$size,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAiStatusRejected.propTypes = iconPropTypes;
}
var AirlineDigitalGate = /*#__PURE__*/React.forwardRef(function AirlineDigitalGate(_ref40, ref) {
  var children = _ref40.children,
      _ref40$size = _ref40.size,
      size = _ref40$size === void 0 ? 16 : _ref40$size,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AirlineDigitalGate.propTypes = iconPropTypes;
}
var AirlineManageGates = /*#__PURE__*/React.forwardRef(function AirlineManageGates(_ref41, ref) {
  var children = _ref41.children,
      _ref41$size = _ref41.size,
      size = _ref41$size === void 0 ? 16 : _ref41$size,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AirlineManageGates.propTypes = iconPropTypes;
}
var AirlinePassengerCare = /*#__PURE__*/React.forwardRef(function AirlinePassengerCare(_ref42, ref) {
  var children = _ref42.children,
      _ref42$size = _ref42.size,
      size = _ref42$size === void 0 ? 16 : _ref42$size,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AirlinePassengerCare.propTypes = iconPropTypes;
}
var AirlineRapidBoard = /*#__PURE__*/React.forwardRef(function AirlineRapidBoard(_ref43, ref) {
  var children = _ref43.children,
      _ref43$size = _ref43.size,
      size = _ref43$size === void 0 ? 16 : _ref43$size,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AirlineRapidBoard.propTypes = iconPropTypes;
}
var Airplay = /*#__PURE__*/React.forwardRef(function Airplay(_ref44, ref) {
  var children = _ref44.children,
      _ref44$size = _ref44.size,
      size = _ref44$size === void 0 ? 16 : _ref44$size,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Airplay.propTypes = iconPropTypes;
}
var AirplayFilled = /*#__PURE__*/React.forwardRef(function AirplayFilled(_ref45, ref) {
  var children = _ref45.children,
      _ref45$size = _ref45.size,
      size = _ref45$size === void 0 ? 16 : _ref45$size,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AirplayFilled.propTypes = iconPropTypes;
}
var Airport_01 = /*#__PURE__*/React.forwardRef(function Airport_01(_ref46, ref) {
  var children = _ref46.children,
      _ref46$size = _ref46.size,
      size = _ref46$size === void 0 ? 16 : _ref46$size,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Airport_01.propTypes = iconPropTypes;
}
var Airport_02 = /*#__PURE__*/React.forwardRef(function Airport_02(_ref47, ref) {
  var children = _ref47.children,
      _ref47$size = _ref47.size,
      size = _ref47$size === void 0 ? 16 : _ref47$size,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Airport_02.propTypes = iconPropTypes;
}
var AirportLocation = /*#__PURE__*/React.forwardRef(function AirportLocation(_ref48, ref) {
  var children = _ref48.children,
      _ref48$size = _ref48.size,
      size = _ref48$size === void 0 ? 16 : _ref48$size,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AirportLocation.propTypes = iconPropTypes;
}
var Alarm = /*#__PURE__*/React.forwardRef(function Alarm(_ref49, ref) {
  var children = _ref49.children,
      _ref49$size = _ref49.size,
      size = _ref49$size === void 0 ? 16 : _ref49$size,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Alarm.propTypes = iconPropTypes;
}
var AlarmAdd = /*#__PURE__*/React.forwardRef(function AlarmAdd(_ref50, ref) {
  var children = _ref50.children,
      _ref50$size = _ref50.size,
      size = _ref50$size === void 0 ? 16 : _ref50$size,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlarmAdd.propTypes = iconPropTypes;
}
var AlarmSubtract = /*#__PURE__*/React.forwardRef(function AlarmSubtract(_ref51, ref) {
  var children = _ref51.children,
      _ref51$size = _ref51.size,
      size = _ref51$size === void 0 ? 16 : _ref51$size,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H21V18H11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlarmSubtract.propTypes = iconPropTypes;
}
var AlignHorizontalCenter = /*#__PURE__*/React.forwardRef(function AlignHorizontalCenter(_ref52, ref) {
  var children = _ref52.children,
      _ref52$size = _ref52.size,
      size = _ref52$size === void 0 ? 16 : _ref52$size,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignHorizontalCenter.propTypes = iconPropTypes;
}
var AlignHorizontalLeft = /*#__PURE__*/React.forwardRef(function AlignHorizontalLeft(_ref53, ref) {
  var children = _ref53.children,
      _ref53$size = _ref53.size,
      size = _ref53$size === void 0 ? 16 : _ref53$size,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignHorizontalLeft.propTypes = iconPropTypes;
}
var AlignHorizontalRight = /*#__PURE__*/React.forwardRef(function AlignHorizontalRight(_ref54, ref) {
  var children = _ref54.children,
      _ref54$size = _ref54.size,
      size = _ref54$size === void 0 ? 16 : _ref54$size,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H28V30H26z",
    transform: "rotate(-180 27 16)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignHorizontalRight.propTypes = iconPropTypes;
}
var AlignVerticalBottom = /*#__PURE__*/React.forwardRef(function AlignVerticalBottom(_ref55, ref) {
  var children = _ref55.children,
      _ref55$size = _ref55.size,
      size = _ref55$size === void 0 ? 16 : _ref55$size,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignVerticalBottom.propTypes = iconPropTypes;
}
var AlignVerticalCenter = /*#__PURE__*/React.forwardRef(function AlignVerticalCenter(_ref56, ref) {
  var children = _ref56.children,
      _ref56$size = _ref56.size,
      size = _ref56$size === void 0 ? 16 : _ref56$size,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignVerticalCenter.propTypes = iconPropTypes;
}
var AlignVerticalTop = /*#__PURE__*/React.forwardRef(function AlignVerticalTop(_ref57, ref) {
  var children = _ref57.children,
      _ref57$size = _ref57.size,
      size = _ref57$size === void 0 ? 16 : _ref57$size,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignVerticalTop.propTypes = iconPropTypes;
}
var AlignBoxBottomCenter = /*#__PURE__*/React.forwardRef(function AlignBoxBottomCenter(_ref58, ref) {
  var children = _ref58.children,
      _ref58$size = _ref58.size,
      size = _ref58$size === void 0 ? 16 : _ref58$size,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H22V20H10z",
    transform: "rotate(-180 16 19)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23H20V25H12z",
    transform: "rotate(-180 16 24)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxBottomCenter.propTypes = iconPropTypes;
}
var AlignBoxBottomLeft = /*#__PURE__*/React.forwardRef(function AlignBoxBottomLeft(_ref59, ref) {
  var children = _ref59.children,
      _ref59$size = _ref59.size,
      size = _ref59$size === void 0 ? 16 : _ref59$size,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H20V20H9zM9 23H16V25H9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxBottomLeft.propTypes = iconPropTypes;
}
var AlignBoxBottomRight = /*#__PURE__*/React.forwardRef(function AlignBoxBottomRight(_ref60, ref) {
  var children = _ref60.children,
      _ref60$size = _ref60.size,
      size = _ref60$size === void 0 ? 16 : _ref60$size,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H23V20H12z",
    transform: "rotate(-180 17.5 19)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23H23V25H16z",
    transform: "rotate(-180 19.5 24)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxBottomRight.propTypes = iconPropTypes;
}
var AlignBoxMiddleCenter = /*#__PURE__*/React.forwardRef(function AlignBoxMiddleCenter(_ref61, ref) {
  var children = _ref61.children,
      _ref61$size = _ref61.size,
      size = _ref61$size === void 0 ? 16 : _ref61$size,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H22V15H10z",
    transform: "rotate(-180 16 14)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H20V20H12z",
    transform: "rotate(-180 16 19)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxMiddleCenter.propTypes = iconPropTypes;
}
var AlignBoxMiddleLeft = /*#__PURE__*/React.forwardRef(function AlignBoxMiddleLeft(_ref62, ref) {
  var children = _ref62.children,
      _ref62$size = _ref62.size,
      size = _ref62$size === void 0 ? 16 : _ref62$size,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H20V15H9zM9 18H16V20H9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxMiddleLeft.propTypes = iconPropTypes;
}
var AlignBoxMiddleRight = /*#__PURE__*/React.forwardRef(function AlignBoxMiddleRight(_ref63, ref) {
  var children = _ref63.children,
      _ref63$size = _ref63.size,
      size = _ref63$size === void 0 ? 16 : _ref63$size,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H23V15H12z",
    transform: "rotate(-180 17.5 14)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H23V20H16z",
    transform: "rotate(-180 19.5 19)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxMiddleRight.propTypes = iconPropTypes;
}
var AlignBoxTopCenter = /*#__PURE__*/React.forwardRef(function AlignBoxTopCenter(_ref64, ref) {
  var children = _ref64.children,
      _ref64$size = _ref64.size,
      size = _ref64$size === void 0 ? 16 : _ref64$size,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7H22V9H10z",
    transform: "rotate(-180 16 8)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V14H12z",
    transform: "rotate(-180 16 13)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxTopCenter.propTypes = iconPropTypes;
}
var AlignBoxTopLeft = /*#__PURE__*/React.forwardRef(function AlignBoxTopLeft(_ref65, ref) {
  var children = _ref65.children,
      _ref65$size = _ref65.size,
      size = _ref65$size === void 0 ? 16 : _ref65$size,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H20V9H9zM9 12H16V14H9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxTopLeft.propTypes = iconPropTypes;
}
var AlignBoxTopRight = /*#__PURE__*/React.forwardRef(function AlignBoxTopRight(_ref66, ref) {
  var children = _ref66.children,
      _ref66$size = _ref66.size,
      size = _ref66$size === void 0 ? 16 : _ref66$size,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7H23V9H12z",
    transform: "rotate(-180 17.5 8)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H23V14H16z",
    transform: "rotate(-180 19.5 13)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AlignBoxTopRight.propTypes = iconPropTypes;
}
var Analytics = /*#__PURE__*/React.forwardRef(function Analytics(_ref67, ref) {
  var children = _ref67.children,
      _ref67$size = _ref67.size,
      size = _ref67$size === void 0 ? 16 : _ref67$size,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Analytics.propTypes = iconPropTypes;
}
var AnalyticsCustom = /*#__PURE__*/React.forwardRef(function AnalyticsCustom(_ref68, ref) {
  var children = _ref68.children,
      _ref68$size = _ref68.size,
      size = _ref68$size === void 0 ? 16 : _ref68$size,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AnalyticsCustom.propTypes = iconPropTypes;
}
var AnalyticsReference = /*#__PURE__*/React.forwardRef(function AnalyticsReference(_ref69, ref) {
  var children = _ref69.children,
      _ref69$size = _ref69.size,
      size = _ref69$size === void 0 ? 16 : _ref69$size,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AnalyticsReference.propTypes = iconPropTypes;
}
var WatsonHealthAngle = /*#__PURE__*/React.forwardRef(function WatsonHealthAngle(_ref70, ref) {
  var children = _ref70.children,
      _ref70$size = _ref70.size,
      size = _ref70$size === void 0 ? 16 : _ref70$size,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAngle.propTypes = iconPropTypes;
}
var WatsonHealthAnnotationVisibility = /*#__PURE__*/React.forwardRef(function WatsonHealthAnnotationVisibility(_ref71, ref) {
  var children = _ref71.children,
      _ref71$size = _ref71.size,
      size = _ref71$size === void 0 ? 16 : _ref71$size,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAnnotationVisibility.propTypes = iconPropTypes;
}
var Aperture = /*#__PURE__*/React.forwardRef(function Aperture(_ref72, ref) {
  var children = _ref72.children,
      _ref72$size = _ref72.size,
      size = _ref72$size === void 0 ? 16 : _ref72$size,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Aperture.propTypes = iconPropTypes;
}
var Api = /*#__PURE__*/React.forwardRef(function Api(_ref73, ref) {
  var children = _ref73.children,
      _ref73$size = _ref73.size,
      size = _ref73$size === void 0 ? 16 : _ref73$size,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Api.propTypes = iconPropTypes;
}
var Api_1 = /*#__PURE__*/React.forwardRef(function Api_1(_ref74, ref) {
  var children = _ref74.children,
      _ref74$size = _ref74.size,
      size = _ref74$size === void 0 ? 16 : _ref74$size,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Api_1.propTypes = iconPropTypes;
}
var App = /*#__PURE__*/React.forwardRef(function App(_ref75, ref) {
  var children = _ref75.children,
      _ref75$size = _ref75.size,
      size = _ref75$size === void 0 ? 16 : _ref75$size,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  App.propTypes = iconPropTypes;
}
var AppConnectivity = /*#__PURE__*/React.forwardRef(function AppConnectivity(_ref76, ref) {
  var children = _ref76.children,
      _ref76$size = _ref76.size,
      size = _ref76$size === void 0 ? 16 : _ref76$size,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AppConnectivity.propTypes = iconPropTypes;
}
var Apple = /*#__PURE__*/React.forwardRef(function Apple(_ref77, ref) {
  var children = _ref77.children,
      _ref77$size = _ref77.size,
      size = _ref77$size === void 0 ? 16 : _ref77$size,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Apple.propTypes = iconPropTypes;
}
var Application = /*#__PURE__*/React.forwardRef(function Application(_ref78, ref) {
  var children = _ref78.children,
      _ref78$size = _ref78.size,
      size = _ref78$size === void 0 ? 16 : _ref78$size,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Application.propTypes = iconPropTypes;
}
var ApplicationMobile = /*#__PURE__*/React.forwardRef(function ApplicationMobile(_ref79, ref) {
  var children = _ref79.children,
      _ref79$size = _ref79.size,
      size = _ref79$size === void 0 ? 16 : _ref79$size,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "14.5",
    cy: "24.5",
    r: "1.5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ApplicationMobile.propTypes = iconPropTypes;
}
var ApplicationVirtual = /*#__PURE__*/React.forwardRef(function ApplicationVirtual(_ref80, ref) {
  var children = _ref80.children,
      _ref80$size = _ref80.size,
      size = _ref80$size === void 0 ? 16 : _ref80$size,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ApplicationVirtual.propTypes = iconPropTypes;
}
var ApplicationWeb = /*#__PURE__*/React.forwardRef(function ApplicationWeb(_ref81, ref) {
  var children = _ref81.children,
      _ref81$size = _ref81.size,
      size = _ref81$size === void 0 ? 16 : _ref81$size,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ApplicationWeb.propTypes = iconPropTypes;
}
var Apps = /*#__PURE__*/React.forwardRef(function Apps(_ref82, ref) {
  var children = _ref82.children,
      _ref82$size = _ref82.size,
      size = _ref82$size === void 0 ? 16 : _ref82$size,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
      d: "M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Apps.propTypes = iconPropTypes;
}
var Archive = /*#__PURE__*/React.forwardRef(function Archive(_ref83, ref) {
  var children = _ref83.children,
      _ref83$size = _ref83.size,
      size = _ref83$size === void 0 ? 16 : _ref83$size,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19H18V21H14z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Archive.propTypes = iconPropTypes;
}
var Area = /*#__PURE__*/React.forwardRef(function Area(_ref84, ref) {
  var children = _ref84.children,
      _ref84$size = _ref84.size,
      size = _ref84$size === void 0 ? 16 : _ref84$size,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Area.propTypes = iconPropTypes;
}
var AreaCustom = /*#__PURE__*/React.forwardRef(function AreaCustom(_ref85, ref) {
  var children = _ref85.children,
      _ref85$size = _ref85.size,
      size = _ref85$size === void 0 ? 16 : _ref85$size,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AreaCustom.propTypes = iconPropTypes;
}
var Arrival = /*#__PURE__*/React.forwardRef(function Arrival(_ref86, ref) {
  var children = _ref86.children,
      _ref86$size = _ref86.size,
      size = _ref86$size === void 0 ? 16 : _ref86$size,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Arrival.propTypes = iconPropTypes;
}
var WatsonHealthArrowAnnotation = /*#__PURE__*/React.forwardRef(function WatsonHealthArrowAnnotation(_ref87, ref) {
  var children = _ref87.children,
      _ref87$size = _ref87.size,
      size = _ref87$size === void 0 ? 16 : _ref87$size,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthArrowAnnotation.propTypes = iconPropTypes;
}
var ArrowDown = /*#__PURE__*/React.forwardRef(function ArrowDown(_ref88, ref) {
  var children = _ref88.children,
      _ref88$size = _ref88.size,
      size = _ref88$size === void 0 ? 16 : _ref88$size,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
      d: "M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowDown.propTypes = iconPropTypes;
}
var ArrowDownLeft = /*#__PURE__*/React.forwardRef(function ArrowDownLeft(_ref89, ref) {
  var children = _ref89.children,
      _ref89$size = _ref89.size,
      size = _ref89$size === void 0 ? 16 : _ref89$size,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowDownLeft.propTypes = iconPropTypes;
}
var ArrowDownRight = /*#__PURE__*/React.forwardRef(function ArrowDownRight(_ref90, ref) {
  var children = _ref90.children,
      _ref90$size = _ref90.size,
      size = _ref90$size === void 0 ? 16 : _ref90$size,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowDownRight.propTypes = iconPropTypes;
}
var ArrowLeft = /*#__PURE__*/React.forwardRef(function ArrowLeft(_ref91, ref) {
  var children = _ref91.children,
      _ref91$size = _ref91.size,
      size = _ref91$size === void 0 ? 16 : _ref91$size,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
      d: "M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowLeft.propTypes = iconPropTypes;
}
var ArrowRight = /*#__PURE__*/React.forwardRef(function ArrowRight(_ref92, ref) {
  var children = _ref92.children,
      _ref92$size = _ref92.size,
      size = _ref92$size === void 0 ? 16 : _ref92$size,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
      d: "M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"
    })), children);
  }

  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
      d: "M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"
    })), children);
  }

  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
      d: "M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowRight.propTypes = iconPropTypes;
}
var ArrowUp = /*#__PURE__*/React.forwardRef(function ArrowUp(_ref93, ref) {
  var children = _ref93.children,
      _ref93$size = _ref93.size,
      size = _ref93$size === void 0 ? 16 : _ref93$size,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
      d: "M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowUp.propTypes = iconPropTypes;
}
var ArrowUpLeft = /*#__PURE__*/React.forwardRef(function ArrowUpLeft(_ref94, ref) {
  var children = _ref94.children,
      _ref94$size = _ref94.size,
      size = _ref94$size === void 0 ? 16 : _ref94$size,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowUpLeft.propTypes = iconPropTypes;
}
var ArrowUpRight = /*#__PURE__*/React.forwardRef(function ArrowUpRight(_ref95, ref) {
  var children = _ref95.children,
      _ref95$size = _ref95.size,
      size = _ref95$size === void 0 ? 16 : _ref95$size,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowUpRight.propTypes = iconPropTypes;
}
var ArrowShiftDown = /*#__PURE__*/React.forwardRef(function ArrowShiftDown(_ref96, ref) {
  var children = _ref96.children,
      _ref96$size = _ref96.size,
      size = _ref96$size === void 0 ? 16 : _ref96$size,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowShiftDown.propTypes = iconPropTypes;
}
var ArrowsHorizontal = /*#__PURE__*/React.forwardRef(function ArrowsHorizontal(_ref97, ref) {
  var children = _ref97.children,
      _ref97$size = _ref97.size,
      size = _ref97$size === void 0 ? 16 : _ref97$size,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowsHorizontal.propTypes = iconPropTypes;
}
var ArrowsVertical = /*#__PURE__*/React.forwardRef(function ArrowsVertical(_ref98, ref) {
  var children = _ref98.children,
      _ref98$size = _ref98.size,
      size = _ref98$size === void 0 ? 16 : _ref98$size,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ArrowsVertical.propTypes = iconPropTypes;
}
var Asleep = /*#__PURE__*/React.forwardRef(function Asleep(_ref99, ref) {
  var children = _ref99.children,
      _ref99$size = _ref99.size,
      size = _ref99$size === void 0 ? 16 : _ref99$size,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
      d: "M7.2,2.3c-1,4.4,1.7,8.7,6.1,9.8c0.1,0,0.1,0,0.2,0c-1.1,1.2-2.7,1.8-4.3,1.8c-0.1,0-0.2,0-0.2,0C5.6,13.8,3,11,3.2,7.7 C3.2,5.3,4.8,3.1,7.2,2.3 M8,1L8,1C4.1,1.6,1.5,5.3,2.1,9.1c0.6,3.3,3.4,5.8,6.8,5.9c0.1,0,0.2,0,0.3,0c2.3,0,4.4-1.1,5.8-3 c0.2-0.2,0.1-0.6-0.1-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-3.9-0.3-6.7-3.8-6.4-7.6C8.3,3,8.4,2.4,8.6,1.8c0.1-0.3,0-0.6-0.3-0.7 C8.1,1,8.1,1,8,1z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Asleep.propTypes = iconPropTypes;
}
var AsleepFilled = /*#__PURE__*/React.forwardRef(function AsleepFilled(_ref100, ref) {
  var children = _ref100.children,
      _ref100$size = _ref100.size,
      size = _ref100$size === void 0 ? 16 : _ref100$size,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AsleepFilled.propTypes = iconPropTypes;
}
var Assembly = /*#__PURE__*/React.forwardRef(function Assembly(_ref101, ref) {
  var children = _ref101.children,
      _ref101$size = _ref101.size,
      size = _ref101$size === void 0 ? 16 : _ref101$size,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9 c0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9 V22.1z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Assembly.propTypes = iconPropTypes;
}
var AssemblyCluster = /*#__PURE__*/React.forwardRef(function AssemblyCluster(_ref102, ref) {
  var children = _ref102.children,
      _ref102$size = _ref102.size,
      size = _ref102$size === void 0 ? 16 : _ref102$size,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AssemblyCluster.propTypes = iconPropTypes;
}
var AssemblyReference = /*#__PURE__*/React.forwardRef(function AssemblyReference(_ref103, ref) {
  var children = _ref103.children,
      _ref103$size = _ref103.size,
      size = _ref103$size === void 0 ? 16 : _ref103$size,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 5.1H12.2V7.1H8.7z",
    transform: "rotate(-30.582 10.48 6.101)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 24.1H11.5V27.6H9.5z",
    transform: "rotate(-59.421 10.48 25.9)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 24.9H23.3V26.9H19.8z",
    transform: "rotate(-30.582 21.502 25.912)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.3H22.5V7.8H20.5z",
    transform: "rotate(-59.421 21.501 6.089)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AssemblyReference.propTypes = iconPropTypes;
}
var Asset = /*#__PURE__*/React.forwardRef(function Asset(_ref104, ref) {
  var children = _ref104.children,
      _ref104$size = _ref104.size,
      size = _ref104$size === void 0 ? 16 : _ref104$size,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Asset.propTypes = iconPropTypes;
}
var AssetConfirm = /*#__PURE__*/React.forwardRef(function AssetConfirm(_ref105, ref) {
  var children = _ref105.children,
      _ref105$size = _ref105.size,
      size = _ref105$size === void 0 ? 16 : _ref105$size,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AssetConfirm.propTypes = iconPropTypes;
}
var AssetDigitalTwin = /*#__PURE__*/React.forwardRef(function AssetDigitalTwin(_ref106, ref) {
  var children = _ref106.children,
      _ref106$size = _ref106.size,
      size = _ref106$size === void 0 ? 16 : _ref106$size,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "14",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.909",
    cy: "5.705",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.787",
    cy: "9.907",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "12.495",
    cy: "8.506",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.201",
    cy: "7.105",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.696",
    cy: "13.187",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "2.133",
    cy: "21.631",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "3.079",
    cy: "24.516",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.848",
    cy: "26.982",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.272",
    cy: "28.81",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "2.098",
    cy: "18.596",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "2.979",
    cy: "15.691",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.081",
    cy: "11.308",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "20.616",
    cy: "4.304",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.323",
    cy: "2.903",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.988",
    cy: "8.89",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "27.587",
    cy: "11.596",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.186",
    cy: "14.303",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.784",
    cy: "17.01",
    r: "1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.383",
    cy: "19.717",
    r: "1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.982",
    cy: "22.424",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.637",
    cy: "27.464",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.092",
    cy: "29.122",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.166",
    cy: "29.932",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.133",
    cy: "29.825",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "20.572",
    cy: "25.125",
    r: "1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.893",
    cy: "3.24",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.188",
    cy: "2.004",
    r: "1"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "26",
    r: "1"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "20",
    r: "1"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "20",
    r: "1"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "6.804",
    cy: "17",
    r: "1"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.196",
    cy: "23",
    r: "1"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25.196",
    r: "1"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "14.804",
    r: "1"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "14.804",
    r: "1"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25.196",
    r: "1"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "6.804",
    cy: "23",
    r: "1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.196",
    cy: "17",
    r: "1"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "6.026",
    r: "1"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AssetDigitalTwin.propTypes = iconPropTypes;
}
var AssetView = /*#__PURE__*/React.forwardRef(function AssetView(_ref107, ref) {
  var children = _ref107.children,
      _ref107$size = _ref107.size,
      size = _ref107$size === void 0 ? 16 : _ref107$size,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AssetView.propTypes = iconPropTypes;
}
var Asterisk = /*#__PURE__*/React.forwardRef(function Asterisk(_ref108, ref) {
  var children = _ref108.children,
      _ref108$size = _ref108.size,
      size = _ref108$size === void 0 ? 16 : _ref108$size,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Asterisk.propTypes = iconPropTypes;
}
var At = /*#__PURE__*/React.forwardRef(function At(_ref109, ref) {
  var children = _ref109.children,
      _ref109$size = _ref109.size,
      size = _ref109$size === void 0 ? 16 : _ref109$size,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  At.propTypes = iconPropTypes;
}
var Attachment = /*#__PURE__*/React.forwardRef(function Attachment(_ref110, ref) {
  var children = _ref110.children,
      _ref110$size = _ref110.size,
      size = _ref110$size === void 0 ? 16 : _ref110$size,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9 C3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1 c0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2 c-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Attachment.propTypes = iconPropTypes;
}
var AudioConsole = /*#__PURE__*/React.forwardRef(function AudioConsole(_ref111, ref) {
  var children = _ref111.children,
      _ref111$size = _ref111.size,
      size = _ref111$size === void 0 ? 16 : _ref111$size,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z",
    transform: "translate(0 .005)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AudioConsole.propTypes = iconPropTypes;
}
var AugmentedReality = /*#__PURE__*/React.forwardRef(function AugmentedReality(_ref112, ref) {
  var children = _ref112.children,
      _ref112$size = _ref112.size,
      size = _ref112$size === void 0 ? 16 : _ref112$size,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "24.5",
    r: "1.5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  AugmentedReality.propTypes = iconPropTypes;
}
var WatsonHealthAutoScroll = /*#__PURE__*/React.forwardRef(function WatsonHealthAutoScroll(_ref113, ref) {
  var children = _ref113.children,
      _ref113$size = _ref113.size,
      size = _ref113$size === void 0 ? 16 : _ref113$size,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthAutoScroll.propTypes = iconPropTypes;
}
var Automatic = /*#__PURE__*/React.forwardRef(function Automatic(_ref114, ref) {
  var children = _ref114.children,
      _ref114$size = _ref114.size,
      size = _ref114$size === void 0 ? 16 : _ref114$size,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Automatic.propTypes = iconPropTypes;
}
var Autoscaling = /*#__PURE__*/React.forwardRef(function Autoscaling(_ref115, ref) {
  var children = _ref115.children,
      _ref115$size = _ref115.size,
      size = _ref115$size === void 0 ? 16 : _ref115$size,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Autoscaling.propTypes = iconPropTypes;
}
var Awake = /*#__PURE__*/React.forwardRef(function Awake(_ref116, ref) {
  var children = _ref116.children,
      _ref116$size = _ref116.size,
      size = _ref116$size === void 0 ? 16 : _ref116$size,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V3.5H7.5z"
    })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
      d: "M10.8 3.4H13.3V4.4H10.8z",
      transform: "rotate(-45.001 12.074 3.922)"
    })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
      d: "M12.5 7.5H15V8.5H12.5z"
    })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
      d: "M11.6 10.8H12.6V13.3H11.6z",
      transform: "rotate(-45.001 12.077 12.075)"
    })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 12.5H8.5V15H7.5z"
    })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
      d: "M2.7 11.6H5.2V12.6H2.7z",
      transform: "rotate(-45.001 3.929 12.078)"
    })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
      d: "M1 7.5H3.5V8.5H1z"
    })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
      d: "M3.4 2.7H4.4V5.2H3.4z",
      transform: "rotate(-45.001 3.926 3.925)"
    })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
      d: "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6.96H15z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M21.67 6.85H26.630000000000003V8.85H21.67z",
    transform: "rotate(-45 24.142 7.85)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 15H30V17H25.04z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15 21.67H25.15V26.630000000000003H23.15z",
    transform: "rotate(-45 24.152 24.146)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.04H17V30H15z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37 23.15H10.33V25.15H5.37z",
    transform: "rotate(-45 7.86 24.144)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H6.96V17H2z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85 5.37H8.85V10.33H6.85z",
    transform: "rotate(-45 7.85 7.848)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Awake.propTypes = iconPropTypes;
}
var Badge = /*#__PURE__*/React.forwardRef(function Badge(_ref117, ref) {
  var children = _ref117.children,
      _ref117$size = _ref117.size,
      size = _ref117$size === void 0 ? 16 : _ref117$size,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Badge.propTypes = iconPropTypes;
}
var BaggageClaim = /*#__PURE__*/React.forwardRef(function BaggageClaim(_ref118, ref) {
  var children = _ref118.children,
      _ref118$size = _ref118.size,
      size = _ref118$size === void 0 ? 16 : _ref118$size,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "26",
    r: "2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  BaggageClaim.propTypes = iconPropTypes;
}
var Bar = /*#__PURE__*/React.forwardRef(function Bar(_ref119, ref) {
  var children = _ref119.children,
      _ref119$size = _ref119.size,
      size = _ref119$size === void 0 ? 16 : _ref119$size,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Bar.propTypes = iconPropTypes;
}
var Barcode = /*#__PURE__*/React.forwardRef(function Barcode(_ref120, ref) {
  var children = _ref120.children,
      _ref120$size = _ref120.size,
      size = _ref120$size === void 0 ? 16 : _ref120$size,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Barcode.propTypes = iconPropTypes;
}
var BareMetalServer = /*#__PURE__*/React.forwardRef(function BareMetalServer(_ref121, ref) {
  var children = _ref121.children,
      _ref121$size = _ref121.size,
      size = _ref121$size === void 0 ? 16 : _ref121$size,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  BareMetalServer.propTypes = iconPropTypes;
}
var BareMetalServer_01 = /*#__PURE__*/React.forwardRef(function BareMetalServer_01(_ref122, ref) {
  var children = _ref122.children,
      _ref122$size = _ref122.size,
      size = _ref122$size === void 0 ? 16 : _ref122$size,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  BareMetalServer_01.propTypes = iconPropTypes;
}
var BareMetalServer_02 = /*#__PURE__*/React.forwardRef(function BareMetalServer_02(_ref123, ref) {
  var children = _ref123.children,
      _ref123$size = _ref123.size,
      size = _ref123$size === void 0 ? 16 : _ref123$size,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  BareMetalServer_02.propTypes = iconPropTypes;
}
var QBarrier = /*#__PURE__*/React.forwardRef(function QBarrier(_ref124, ref) {
  var children = _ref124.children,
      _ref124$size = _ref124.size,
      size = _ref124$size === void 0 ? 16 : _ref124$size,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  QBarrier.propTypes = iconPropTypes;
}
var Basketball = /*#__PURE__*/React.forwardRef(function Basketball(_ref125, ref) {
  var children = _ref125.children,
      _ref125$size = _ref125.size,
      size = _ref125$size === void 0 ? 16 : _ref125$size,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Basketball.propTypes = iconPropTypes;
}

export { Accessibility, AccessibilityAlt, AccessibilityColor, AccessibilityColorFilled, Account, AccumulationIce, AccumulationPrecipitation, AccumulationRain, AccumulationSnow, Activity, Add, AddAlt, AddComment, AddFilled, AgricultureAnalytics, AirlineDigitalGate, AirlineManageGates, AirlinePassengerCare, AirlineRapidBoard, Airplay, AirplayFilled, AirportLocation, Airport_01, Airport_02, Alarm, AlarmAdd, AlarmSubtract, AlignBoxBottomCenter, AlignBoxBottomLeft, AlignBoxBottomRight, AlignBoxMiddleCenter, AlignBoxMiddleLeft, AlignBoxMiddleRight, AlignBoxTopCenter, AlignBoxTopLeft, AlignBoxTopRight, AlignHorizontalCenter, AlignHorizontalLeft, AlignHorizontalRight, AlignVerticalBottom, AlignVerticalCenter, AlignVerticalTop, Analytics, AnalyticsCustom, AnalyticsReference, Aperture, Api, Api_1, App, AppConnectivity, Apple, Application, ApplicationMobile, ApplicationVirtual, ApplicationWeb, Apps, Archive, Area, AreaCustom, Arrival, ArrowDown, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowRight, ArrowShiftDown, ArrowUp, ArrowUpLeft, ArrowUpRight, ArrowsHorizontal, ArrowsVertical, Asleep, AsleepFilled, Assembly, AssemblyCluster, AssemblyReference, Asset, AssetConfirm, AssetDigitalTwin, AssetView, Asterisk, At, Attachment, AudioConsole, AugmentedReality, Automatic, Autoscaling, Awake, Badge, BaggageClaim, Bar, Barcode, BareMetalServer, BareMetalServer_01, BareMetalServer_02, Basketball, QBarrier, WatsonHealth3DCursor, WatsonHealth3DCursorAlt, WatsonHealth3DCurveAutoColon, WatsonHealth3DCurveAutoVessels, WatsonHealth3DCurveManual, WatsonHealth3DICa, WatsonHealth3DMprToggle, WatsonHealth3DPrintMesh, WatsonHealth3DSoftware, WatsonHealth3rdPartyConnected, WatsonHealthAiResults, WatsonHealthAiResultsHigh, WatsonHealthAiResultsLow, WatsonHealthAiResultsMedium, WatsonHealthAiResultsUrgent, WatsonHealthAiResultsVeryHigh, WatsonHealthAiStatus, WatsonHealthAiStatusComplete, WatsonHealthAiStatusFailed, WatsonHealthAiStatusInProgress, WatsonHealthAiStatusQueued, WatsonHealthAiStatusRejected, WatsonHealthAngle, WatsonHealthAnnotationVisibility, WatsonHealthArrowAnnotation, WatsonHealthAutoScroll, _4K, _4KFilled };
